/*
 * MisakaZoo: テーマの表示切替ボタン（大きく／小さく／リスト）を
 * スマートフィルター＆サーチ（Globo）の商品一覧につなぐ。
 * 選んだ表示はブラウザに覚えさせ、次のコレクションでも同じ表示にする。
 * 説明書: mz_spapi\説明書（マークダウン）\rule_collection_view_toggle.md
 */
(function () {
  var KEY = 'mzGridView';
  var VIEWS = ['large', 'medium', 'list'];

  function read() {
    try {
      var v = localStorage.getItem(KEY);
      return VIEWS.indexOf(v) >= 0 ? v : 'medium';
    } catch (e) {
      return 'medium';
    }
  }

  function save(v) {
    try { localStorage.setItem(KEY, v); } catch (e) {}
  }

  function apply(v) {
    document.documentElement.setAttribute('data-mz-view', v);
    var btns = document.querySelectorAll('.grid-view-btn');
    for (var i = 0; i < btns.length; i++) {
      var on = btns[i].getAttribute('data-view') === v;
      btns[i].classList.toggle('is-active', on);
      btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  // テーマ本来の処理（テーマ自身の一覧を切り替える＝今は何も起きない）より先に受け取る
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.grid-view-btn') : null;
    if (!b) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var v = b.getAttribute('data-view');
    if (VIEWS.indexOf(v) < 0) v = 'medium';
    save(v);
    apply(v);
  }, true);

  apply(read());
  document.addEventListener('DOMContentLoaded', function () { apply(read()); });
  window.addEventListener('load', function () {
    apply(read());
    // ボタンはテーマが後から描き直すことがあるので、少し後にもう一度合わせる
    setTimeout(function () { apply(read()); }, 1500);
  });
})();
